import React, { useEffect, useState } from 'react';
import {
  Button,
  Grid,
  Typography,
  TextField,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel
} from '@mui/material';
import { Box } from '@mui/system';
import { Document, pdfjs, Page as Pages } from 'react-pdf';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { HiOutlineArrowNarrowLeft, HiOutlineArrowNarrowRight } from 'react-icons/hi';

// table component
import { styled } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { fDate } from '../../../../utils/formatTime';
import IndividualCommission from '../../IndividualCommission';
import VolumeCommission from '../../VolumeCommission';
import AgreementService from '../../../services/AgreementService';
import { setApiError } from '../../../../store/Slice/Error/ErrorSlice';
import useLoginSelector from '../../../../store/Slice/Login/LoginSelector';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 12,
    padding: '6px',
    height: '42.5px',
    fontWeight: 500,
    textTransform: 'uppercase',
    color: '#0d4689'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    padding: '4px 6px',
    height: '42.5px'
  }
}));

const { SaveCommissionInfo, Edit, DeleteCommissionInfo, LoanMasterList } = AgreementService;

export default function AggrementAddStep3({
  handlePrev,
  setActiveStep,
  reviewData,
  setReviewData
}) {
  const navigate = useNavigate();
  const [open2, setOpen2] = useState(false);
  const [validationMsg2, setValidationMsg2] = useState('');
  const [loanTypesList, setLoanTypesList] = useState([]);
  const [branches, setBranches] = useState([]);
  const [turnoverBenefitValue, setTurnoverBenefitValue] = useState(false);
  const [individualItemIndexEdit, setIndividualItemIndexEdit] = useState(null);
  const [individualItemListEdit, setIndividualItemListEdit] = useState({});
  const [volumeItemIndexEdit, setVolumeItemIndexEdit] = useState(null);
  const [volumeItemListEdit, setVolumeItemListEdit] = useState({});
  const [branchItemIndv, setBranchItemIndv] = useState({});
  const [branchIndexIndv, setBranchIndexIndv] = useState(null);
  const [branchItemVolume, setBranchItemVolume] = useState({});
  const [branchIndexVolume, setBranchIndexVolume] = useState(null);
  const [individualCommissionEdit, setIndividualCommissionEdit] = useState(false);
  const [volumeCommissionEdit, setVolumeCommissionEdit] = useState(false);
  const [deleteConfirm1, setDeleteConfirm1] = useState(false);
  const [deleteConfirm2, setDeleteConfirm2] = useState(false);
  const [agreementBankId1, setAgreementBankId1] = useState('');

  const commissionStructureTypes = {
    INDIVIDUAL: {
      typeName: 'INDIVIDUAL',
      typeId: 70
    },
    VOLUME: {
      typeName: 'VOLUME',
      typeId: 72
    },
    BOTH: {
      typeName: 'BOTH',
      typeId: 74
    }
  };
  const [showHide, setShowHide] = useState(commissionStructureTypes.INDIVIDUAL.typeId);
  const [individualCommission, setIndividualCommission] = useState({
    loanType: ' ',
    branch: ' ',
    commission: '',
    startDate: null,
    endDate: null,
    isIndividualCommissionType: null,
    aggrementCommissionId: null
  });
  const [individualArrayList, setIndividualArrayList] = useState([]);
  const [individualCommissionEditList, setIndividualCommissionEditList] = useState({
    loanType: ' ',
    branch: ' ',
    commission: '',
    isIndividualCommissionType: null,
    aggrementCommissionId: null
  });
  const [volumeArray, setVolumeArray] = useState({
    loanType: ' ',
    branch: ' ',
    amount: '',
    duration: '',
    commission: '',
    unit: '',
    isIndividualCommissionType: null,
    aggrementCommissionId: null
  });
  const [volumeArrayList, setVolumeArrayList] = useState([]);
  const [volumeArrayEditList, setVolumeArrayEditList] = useState({
    loanType: ' ',
    branch: ' ',
    amount: '',
    duration: '',
    commission: '',
    unit: '',
    isIndividualCommissionType: null,
    aggrementCommissionId: null
  });
  const [commissionDateRange, setCommissionDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ]);

  const dispatch = useDispatch();
  const { LoginData } = useLoginSelector();

  const handleShowHide = (event) => {
    const getUserType = Number(event.target.value);
    setShowHide(getUserType);
    localStorage.setItem('commisssionType', getUserType);

    setIndividualCommission({
      loanType: ' ',
      branch: ' ',
      commission: ''
    });
    setVolumeArray({
      loanType: ' ',
      branch: ' ',
      amount: '',
      duration: '',
      commission: '',
      unit: ''
    });
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  const handleAddIndividualEdit = (e) => {
    if (individualCommissionEditList.loanType === ' ') {
      setOpen2(true);
      setValidationMsg2('Please select loan type');
      return;
    }
    if (individualCommissionEditList.branch === ' ') {
      setOpen2(true);
      setValidationMsg2('Please select branch');
      return;
    }
    if (individualCommissionEditList.commission === '') {
      setOpen2(true);
      setValidationMsg2('Please enter commission %');
      return;
    } else if (individualCommissionEditList.commission > 100) {
      setOpen2(true);
      setValidationMsg2('Please enter valid commission %');
      setIndividualCommissionEditList({
        ...individualCommissionEditList,
        commission: ''
      });
      return;
    }

    if (
      Object.keys(individualItemListEdit).length > 0 &&
      individualItemListEdit.aggrementCommissionId !== null
    ) {
      const prevArray = individualCommissionEditList;
      prevArray.isIndividualCommissionType = true;
      prevArray.aggrementCommissionId = individualItemListEdit.aggrementCommissionId;
      setIndividualCommissionEditList(prevArray);
    } else {
      const prevArray = individualCommissionEditList;
      prevArray.isIndividualCommissionType = true;
      prevArray.aggrementCommissionId = null;
      setIndividualCommissionEditList(prevArray);
    }

    const newLoanNameInd = JSON.parse(individualCommissionEditList.loanType).loanName;
    const newBranchNameInd = JSON.parse(individualCommissionEditList.branch).branchName;
    const filteredDataInd = individualArrayList.filter(
      (item, index) => individualItemIndexEdit !== index
    );
    const filteredDataInd2 = filteredDataInd.filter(
      (item) =>
        JSON.parse(item.loanType).loanName === newLoanNameInd &&
        JSON.parse(item.branch).branchName === newBranchNameInd
    );

    if (filteredDataInd2.length > 0) {
      setOpen2(true);
      setValidationMsg2('Loan Name already exists - Please try entering with another Loan Name');
    } else {
      const newArray = individualArrayList;
      const index = newArray.indexOf(individualItemListEdit);
      if (index === individualItemIndexEdit) {
        newArray[index] = individualCommissionEditList;
      }
      setIndividualCommissionEdit(false);
    }
  };

  const individualEditDialogOpen = (e, itemList, indexValue) => {
    setIndividualCommissionEdit(true);
    setIndividualCommissionEditList({
      loanType: itemList ? itemList.loanType : ' ',
      branch: itemList ? itemList.branch : ' ',
      commission: itemList ? itemList.commission : '',
      isIndividualCommissionType: itemList ? itemList.isIndividualCommissionType : null,
      aggrementCommissionId: itemList ? itemList.aggrementCommissionId : null
    });
    setIndividualItemListEdit(itemList);
    setIndividualItemIndexEdit(indexValue);
  };

  const individualDeleteDialogOpen = (e, itemList, indexValue) => {
    setBranchItemIndv(itemList);
    setBranchIndexIndv(indexValue);
    setDeleteConfirm1(true);
  };

  const handleDeleteBranchIndv = (e, branchItemIndv, branchIndexIndv) => {
    const getLocalData = localStorage.getItem('reviewData');
    if (getLocalData) {
      const parsedData = JSON.parse(getLocalData);
      if (parsedData.SaveCommissionInfo) {
        if (parsedData.SaveCommissionInfo[branchIndexIndv]) {
          (async () => {
            const credentials = {
              agreementCommissionId:
                parsedData.SaveCommissionInfo[branchIndexIndv].aggrementCommissionId,
              companyId: LoginData?.companyId,
              userId: LoginData?.userId
            };
            const DeleteBranch = await DeleteCommissionInfo(credentials, LoginData?.jwt);
            if (DeleteBranch.status === 'success') {
              const newArray = individualArrayList;
              newArray.splice(branchIndexIndv, 1);

              const parsedDataArray = parsedData.SaveCommissionInfo;
              parsedDataArray.splice(branchIndexIndv, 1);

              setReviewData({
                ...reviewData,
                SaveCommissionInfo: parsedDataArray
              });
              localStorage.setItem(
                'reviewData',
                JSON.stringify({
                  ...reviewData,
                  SaveCommissionInfo: parsedDataArray
                })
              );
            }
          })();
        } else {
          const newArray = individualArrayList;
          newArray.splice(branchIndexIndv, 1);
        }
      } else {
        const newArray = individualArrayList;
        newArray.splice(branchIndexIndv, 1);
      }

      setDeleteConfirm1(false);
    }
  };

  const handleDeleteBranchVolume = (e, branchItemVolume, branchIndexVolume) => {
    const getLocalData = localStorage.getItem('reviewData');
    if (getLocalData) {
      const parsedData = JSON.parse(getLocalData);
      if (parsedData.SaveCommissionInfo) {
        if (parsedData.SaveCommissionInfo[branchIndexVolume]) {
          (async () => {
            const credentials = {
              agreementCommissionId:
                parsedData.SaveCommissionInfo[branchIndexVolume].aggrementCommissionId,
              companyId: LoginData?.companyId,
              userId: LoginData?.userId
            };
            const DeleteBranch = await DeleteCommissionInfo(credentials, LoginData?.jwt);
            if (DeleteBranch.status === 'success') {
              const newArray = volumeArrayList;
              newArray.splice(branchIndexVolume, 1);

              const parsedDataArray = parsedData.SaveCommissionInfo;
              parsedDataArray.splice(branchIndexVolume, 1);

              setReviewData({
                ...reviewData,
                SaveCommissionInfo: parsedDataArray
              });

              localStorage.setItem(
                'reviewData',
                JSON.stringify({
                  ...reviewData,
                  SaveCommissionInfo: parsedDataArray
                })
              );
            }
          })();
        } else {
          const newArray = volumeArrayList;
          newArray.splice(branchIndexVolume, 1);
        }
      } else {
        const newArray = volumeArrayList;
        newArray.splice(branchIndexVolume, 1);
      }

      setDeleteConfirm2(false);
    }
  };

  const handleAddVolumeEdit = (e) => {
    if (volumeArrayEditList.loanType === ' ') {
      setOpen2(true);
      setValidationMsg2('Please select loan type');
      return;
    }
    if (volumeArrayEditList.branch === ' ') {
      setOpen2(true);
      setValidationMsg2('Please select branch');
      return;
    }
    if (volumeArrayEditList.amount === '') {
      setOpen2(true);
      setValidationMsg2('Please enter amount');
      return;
    }
    if (volumeArrayEditList.duration === '') {
      setOpen2(true);
      setValidationMsg2('Please enter duration');
      return;
    }
    if (volumeArrayEditList.commission === '') {
      setOpen2(true);
      setValidationMsg2('Please enter commission');
      return;
    }
    if (volumeArrayEditList.unit === '') {
      setOpen2(true);
      setValidationMsg2('Please enter unit');
      return;
    } else if (volumeArrayEditList.commission > 100) {
      setOpen2(true);
      setValidationMsg2('Please enter valid commission %');
      setVolumeArrayEditList({
        ...volumeArrayEditList,
        commission: ''
      });
      return;
    }

    if (
      Object.keys(volumeItemListEdit).length > 0 &&
      volumeItemListEdit.aggrementCommissionId !== null
    ) {
      const prevArray = volumeArrayEditList;
      prevArray.isIndividualCommissionType = false;
      prevArray.aggrementCommissionId = volumeItemListEdit.aggrementCommissionId;
      setVolumeArrayEditList(prevArray);
    } else {
      const prevArray = volumeArrayEditList;
      prevArray.isIndividualCommissionType = false;
      prevArray.aggrementCommissionId = null;
      setVolumeArrayEditList(prevArray);
    }

    const newLoanNameVol = JSON.parse(volumeArrayEditList.loanType).loanName;

    const newBranchNameVol = JSON.parse(volumeArrayEditList.branch).branchName;

    const filteredDataVol = volumeArrayList.filter((item, index) => volumeItemIndexEdit !== index);
    const filteredDataVol2 = filteredDataVol.filter(
      (item) =>
        JSON.parse(item.loanType).loanName === newLoanNameVol &&
        JSON.parse(item.branch).branchName === newBranchNameVol
    );

    if (filteredDataVol2.length > 0) {
      setOpen2(true);
      setValidationMsg2('Loan Name already exists - Please try entering with another Loan Name');
    } else {
      const newArray = volumeArrayList;
      const index = newArray.indexOf(volumeItemListEdit);
      if (index === volumeItemIndexEdit) {
        newArray[index] = volumeArrayEditList;
      }
      setVolumeCommissionEdit(false);
    }
  };

  const volumeEditDialogOpen = (e, itemListVolume, indexValueVolume) => {
    setVolumeCommissionEdit(true);
    setVolumeArrayEditList({
      loanType: itemListVolume ? itemListVolume.loanType : ' ',
      branch: itemListVolume ? itemListVolume.branch : ' ',
      amount: itemListVolume ? itemListVolume.amount : '',
      duration: itemListVolume ? itemListVolume.duration : '',
      commission: itemListVolume ? itemListVolume.commission : '',
      unit: itemListVolume ? itemListVolume.unit : '',
      isIndividualCommissionType: itemListVolume ? itemListVolume.isIndividualCommissionType : null,
      aggrementCommissionId: itemListVolume ? itemListVolume.aggrementCommissionId : null
    });

    setVolumeItemListEdit(itemListVolume);
    setVolumeItemIndexEdit(indexValueVolume);
  };

  const volumeDeleteDialogOpen = (e, itemListVolume, indexValueVolume) => {
    setBranchItemVolume(itemListVolume);
    setBranchIndexVolume(indexValueVolume);

    setDeleteConfirm2(true);
  };

  const handleNextStep3 = async (e) => {
    const localJWTtoken = JSON.parse(localStorage.getItem('agreementId'));
    const authAgreementId = localJWTtoken.agreementId;
    const authCompanyId = localJWTtoken.companyId;
    const authUserId = localJWTtoken.userId;

    const newArrayCredential = [];
    const startDate = commissionDateRange[0].startDate
      ? new Date(commissionDateRange[0].startDate).toISOString()
      : null;

    const endDate = commissionDateRange[0].endDate
      ? new Date(commissionDateRange[0].endDate).toISOString()
      : null;
    const combineArrayBoth = [];
    if (individualArrayList.length > 0 && volumeArrayList.length > 0) {
      combineArrayBoth.push(...individualArrayList, ...volumeArrayList);
    }

    if (showHide === commissionStructureTypes.INDIVIDUAL.typeId) {
      if (individualArrayList.length === 0) {
        setOpen2(true);
        setValidationMsg2('Please add individual commission structure');
        return;
      }
      individualArrayList.forEach((item, index) => {
        const credential = {
          aggrementCommissionId: item.aggrementCommissionId,
          aggrementCommissionPercentage: Number(item.commission),
          aggrementCommissionTypeId: showHide,
          aggrementId: authAgreementId,
          amount: null,
          bankId: agreementBankId1 !== '' ? agreementBankId1 : null,
          branchId: JSON.parse(item.branch).branchId,
          companyId: authCompanyId,
          duration: null,
          isIndividualCommissionType: item.isIndividualCommissionType,
          loanTypeId: JSON.parse(item.loanType).loanId,
          unit: null,
          userId: authUserId,
          startDate: startDate || null,
          endDate: endDate || null
        };

        const getLocalData = localStorage.getItem('reviewData');
        if (getLocalData) {
          const parsedData = JSON.parse(getLocalData);
          if (parsedData.SaveCommissionInfo) {
            if (parsedData.SaveCommissionInfo[index]) {
              credential.aggrementCommissionId =
                parsedData.SaveCommissionInfo[index].aggrementCommissionId;
            }
          }
        }

        newArrayCredential.push(credential);
      });
    } else if (showHide === commissionStructureTypes.VOLUME.typeId) {
      if (volumeArrayList.length === 0) {
        setOpen2(true);
        setValidationMsg2('Please add volume commission structure');
        return;
      }
      volumeArrayList.forEach((item, index) => {
        const credential = {
          aggrementCommissionId: item.aggrementCommissionId,
          aggrementCommissionPercentage: Number(item.commission),
          aggrementCommissionTypeId: showHide,
          aggrementId: authAgreementId,
          amount: Number(item.amount),
          bankId: agreementBankId1 !== '' ? agreementBankId1 : null,
          branchId: JSON.parse(item.branch).branchId,
          companyId: authCompanyId,
          duration: Number(item.duration),
          loanTypeId: JSON.parse(item.loanType).loanId,
          unit: Number(item.unit),
          userId: authUserId,
          isIndividualCommissionType: item.isIndividualCommissionType,
          startDate: startDate || null,
          endDate: endDate || null
        };
        const getLocalData = localStorage.getItem('reviewData');
        if (getLocalData) {
          const parsedData = JSON.parse(getLocalData);
          if (parsedData.SaveCommissionInfo) {
            if (parsedData.SaveCommissionInfo[index]) {
              credential.aggrementCommissionId =
                parsedData.SaveCommissionInfo[index].aggrementCommissionId;
            }
          }
        }

        newArrayCredential.push(credential);
      });
    } else {
      if (combineArrayBoth.length === 0) {
        setOpen2(true);
        setValidationMsg2('Please enter both individual and volume commission structure');
        return;
      }
      combineArrayBoth.forEach((item, index) => {
        const credential = {
          aggrementCommissionId: item.aggrementCommissionId,
          aggrementCommissionPercentage: Number(item.commission),
          aggrementCommissionTypeId: showHide,
          aggrementId: authAgreementId,
          amount: Number(item.amount),
          bankId: agreementBankId1 !== '' ? agreementBankId1 : null,
          branchId: JSON.parse(item.branch).branchId,
          companyId: authCompanyId,
          duration: Number(item.duration),
          loanTypeId: JSON.parse(item.loanType).loanId,
          unit: Number(item.unit),
          userId: authUserId,
          isIndividualCommissionType: item.isIndividualCommissionType,
          startDate: startDate || null,
          endDate: endDate || null
        };
        const getLocalData = localStorage.getItem('reviewData');
        if (getLocalData) {
          const parsedData = JSON.parse(getLocalData);
          if (parsedData.SaveCommissionInfo) {
            if (parsedData.SaveCommissionInfo[index]) {
              credential.aggrementCommissionId =
                parsedData.SaveCommissionInfo[index].aggrementCommissionId;
            }
          }
        }
        newArrayCredential.push(credential);
      });
    }

    const credential1 = {
      aggrementId: authAgreementId,
      agreementCommissions: newArrayCredential,
      companyId: authCompanyId,
      currentAggrementCommissionTypeId: showHide,
      userId: authUserId
    };

    const SaveCommissionInfoApi = await SaveCommissionInfo(credential1, LoginData?.jwt);
    if (SaveCommissionInfoApi.status === 'success') {
      setActiveStep((activeStep) => activeStep + 1);
      let individualCommissionData = [];
      let volumeCommissionData = [];
      if (showHide === commissionStructureTypes.INDIVIDUAL.typeId) {
        individualCommissionData = [];
        individualCommissionData = individualArrayList ? individualArrayList : null;
      } else if (showHide === commissionStructureTypes.VOLUME.typeId) {
        volumeCommissionData = [];
        volumeCommissionData = volumeArrayList ? volumeArrayList : null;
      } else {
        individualCommissionData = [];
        individualCommissionData = individualArrayList ? individualArrayList : null;
        volumeCommissionData = [];
        volumeCommissionData = volumeArrayList ? volumeArrayList : null;
      }

      setReviewData({
        ...reviewData,
        commissionDetails: {
          individual: individualCommissionData.length > 0 ? individualCommissionData : [],
          volume: volumeCommissionData.length > 0 ? volumeCommissionData : []
        },
        SaveCommissionInfo: SaveCommissionInfoApi.data.commissions
      });

      const getUserType1 = SaveCommissionInfoApi.data.commissions[0].aggrementCommissionTypeId;

      localStorage.setItem('commisssionType', getUserType1);

      localStorage.setItem(
        'reviewData',
        JSON.stringify({
          ...reviewData,
          commissionDetails: {
            individual: individualCommissionData.length > 0 ? individualCommissionData : [],
            volume: volumeCommissionData.length > 0 ? volumeCommissionData : []
          },
          SaveCommissionInfo: SaveCommissionInfoApi.data.commissions
        })
      );
    } else {
      dispatch(setApiError('Something went wrong'));
    }
  };

  useEffect(async () => {
    const localJWTtoken = JSON.parse(localStorage.getItem('agreementId'));
    if (localJWTtoken === null) {
      return true;
    }
    const authAgreementId = localJWTtoken.agreementId;
    const authCommisssionType = JSON.parse(localStorage.getItem('commisssionType'));

    if (authCommisssionType !== null) {
      setShowHide(Number(authCommisssionType));
    }

    if (LoginData === null) {
      return true;
    }

    const authCompanyId1 = LoginData?.companyId;
    const authUserId1 = LoginData?.userId;
    // setUserId(authUserId);

    const LoanTypesApiResponse = await LoanMasterList(
      {
        companyId: authCompanyId1
      },
      LoginData?.jwt
    );
    if (LoanTypesApiResponse.msg) {
      if (LoanTypesApiResponse.msg === 'Forbidden') {
        navigate('/');
      }
    }
    if (LoanTypesApiResponse.status === 'success') {
      setLoanTypesList(LoanTypesApiResponse.data.loanTypes);
    }

    const credentials = {
      aggrementId: authAgreementId,
      companyId: authCompanyId1,
      userId: authUserId1
    };
    const EditApiResponse = await Edit(credentials, LoginData?.jwt);
    if (EditApiResponse.status === 'success') {
      if (EditApiResponse.data !== null && EditApiResponse.data.commissionDetails !== undefined) {
        const turnoverBenefit = EditApiResponse.data.bankDetails.turnoverBenefit;
        if (turnoverBenefit === false) {
          setTurnoverBenefitValue(true);
        } else {
          setTurnoverBenefitValue(false);
        }
        EditApiResponse.data.commissionDetails.commissions.forEach((item, index) => {
          if (item.aggrementCommissionTypeId === commissionStructureTypes.INDIVIDUAL.typeId) {
            setShowHide(commissionStructureTypes.INDIVIDUAL.typeId);
          } else if (item.aggrementCommissionTypeId === commissionStructureTypes.VOLUME.typeId) {
            setShowHide(commissionStructureTypes.VOLUME.typeId);
          } else {
            setShowHide(commissionStructureTypes.BOTH.typeId);
          }
          const filtredData = EditApiResponse.data.commissionDetails.commissions.filter(
            (item) =>
              (item.aggrementCommissionTypeId === commissionStructureTypes.BOTH.typeId &&
                item.isIndividualCommissionType === true) ||
              (item.aggrementCommissionTypeId === commissionStructureTypes.INDIVIDUAL.typeId &&
                item.isIndividualCommissionType === true)
          );

          const indArray = [];
          filtredData.forEach((item, index) => {
            const branchStr = {
              branchId: item.branchId,
              branchName: item.branchName
            };
            const loanArray = {
              loanId: item.loanTypeId,
              loanName: item.loanTypeName
            };
            const indData = {
              branch: JSON.stringify(branchStr),
              commission: item.aggrementCommissionPercentage,
              isIndividualCommissionType: true,
              aggrementCommissionId: item.aggrementCommissionId,
              loanType: JSON.stringify(loanArray)
            };
            indArray.push(indData);
          });

          if (indArray.length > 0) {
            setIndividualArrayList(indArray);
          }

          const filtredData2 = EditApiResponse.data.commissionDetails.commissions.filter(
            (item) =>
              (item.aggrementCommissionTypeId === commissionStructureTypes.BOTH.typeId &&
                item.isIndividualCommissionType === false) ||
              (item.aggrementCommissionTypeId === commissionStructureTypes.VOLUME.typeId &&
                item.isIndividualCommissionType === false)
          );
          const volArray = [];
          filtredData2.forEach((item, index) => {
            const branchStr1 = {
              branchId: item.branchId,
              branchName: item.branchName
            };
            const loanArray1 = {
              loanId: item.loanTypeId,
              loanName: item.loanTypeName
            };
            const volData = {
              amount: item.amount,
              branch: JSON.stringify(branchStr1),
              commission: item.aggrementCommissionPercentage,
              duration: item.duration,
              isIndividualCommissionType: false,
              aggrementCommissionId: item.aggrementCommissionId,
              loanType: JSON.stringify(loanArray1),
              unit: item.unit ? item.unit : null
            };
            volArray.push(volData);
          });
          if (volArray.length > 0) {
            setVolumeArrayList(volArray);
          }
        });
      }
    }

    let authReviewData = '';

    setTimeout(() => {
      authReviewData = JSON.parse(localStorage.getItem('reviewData'));
      if (authReviewData !== null) {
        const turnoverBenefit = authReviewData.bankDetails.turnoverBenefit.typeId;
        if (turnoverBenefit === 'false') {
          setTurnoverBenefitValue(true);
        } else {
          setTurnoverBenefitValue(false);
        }

        setAgreementBankId1(authReviewData.agreementBankId);

        if (authReviewData.branchDetails && authReviewData.branchDetails.length > 0) {
          setBranches(authReviewData.branchDetails);
        } else {
          setBranches([]);
        }
      }
    }, 500);
  }, []);

  return (
    <>
      <Box className="">
        <Box className="displayFlex alignItemCenter" mb={2}>
          <Typography variant="body2" className="mr-2">
            Commision Structure
          </Typography>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue={commissionStructureTypes.INDIVIDUAL.typeId}
              name="radio-buttons-group"
              value={showHide}
              row
              onChange={(e) => {
                handleShowHide(e);
              }}
            >
              <FormControlLabel
                value={commissionStructureTypes.INDIVIDUAL.typeId}
                control={<Radio size="small" />}
                sx={{ marginRight: '1rem' }}
                label={
                  <Typography variant="body2">
                    <strong>Individual</strong>
                  </Typography>
                }
              />
              <FormControlLabel
                value={commissionStructureTypes.VOLUME.typeId}
                control={<Radio size="small" />}
                sx={{ marginRight: '1rem' }}
                disabled={turnoverBenefitValue}
                label={
                  <Typography variant="body2">
                    <strong>Volume</strong>
                  </Typography>
                }
              />
              <FormControlLabel
                value={commissionStructureTypes.BOTH.typeId}
                control={<Radio size="small" />}
                sx={{ marginRight: '1rem' }}
                disabled={turnoverBenefitValue}
                label={
                  <Typography variant="body2">
                    <strong>Both</strong>
                  </Typography>
                }
              />
            </RadioGroup>
          </FormControl>
        </Box>
        {showHide === commissionStructureTypes.INDIVIDUAL.typeId && (
          <IndividualCommission
            StyledTableCell={StyledTableCell}
            StyledTableRow={StyledTableRow}
            setOpen2={setOpen2}
            setValidationMsg2={setValidationMsg2}
            individualArrayList={individualArrayList}
            setIndividualArrayList={setIndividualArrayList}
            loanTypesList={loanTypesList}
            individualCommission={individualCommission}
            setIndividualCommission={setIndividualCommission}
            branches={branches}
            setIndividualCommissionEdit={setIndividualCommissionEdit}
            setDeleteConfirm1={setDeleteConfirm1}
            individualEditDialogOpen={individualEditDialogOpen}
            individualDeleteDialogOpen={individualDeleteDialogOpen}
          />
        )}
        {showHide === commissionStructureTypes.VOLUME.typeId && (
          <VolumeCommission
            StyledTableCell={StyledTableCell}
            StyledTableRow={StyledTableRow}
            setOpen2={setOpen2}
            setValidationMsg2={setValidationMsg2}
            volumeArray={volumeArray}
            setVolumeArray={setVolumeArray}
            volumeArrayList={volumeArrayList}
            setVolumeArrayList={setVolumeArrayList}
            loanTypesList={loanTypesList}
            branches={branches}
            setDeleteConfirm2={setDeleteConfirm2}
            setVolumeCommissionEdit={setVolumeCommissionEdit}
            volumeEditDialogOpen={volumeEditDialogOpen}
            volumeDeleteDialogOpen={volumeDeleteDialogOpen}
          />
        )}
        {showHide === commissionStructureTypes.BOTH.typeId && (
          <>
            <Box mb={3}>
              <IndividualCommission
                StyledTableCell={StyledTableCell}
                StyledTableRow={StyledTableRow}
                setOpen2={setOpen2}
                setValidationMsg2={setValidationMsg2}
                individualArrayList={individualArrayList}
                setIndividualArrayList={setIndividualArrayList}
                loanTypesList={loanTypesList}
                individualCommission={individualCommission}
                setIndividualCommission={setIndividualCommission}
                branches={branches}
                setDeleteConfirm1={setDeleteConfirm1}
                setIndividualCommissionEdit={setIndividualCommissionEdit}
                individualEditDialogOpen={individualEditDialogOpen}
                individualDeleteDialogOpen={individualDeleteDialogOpen}
              />
            </Box>
            <VolumeCommission
              StyledTableCell={StyledTableCell}
              StyledTableRow={StyledTableRow}
              setOpen2={setOpen2}
              setValidationMsg2={setValidationMsg2}
              volumeArray={volumeArray}
              setVolumeArray={setVolumeArray}
              volumeArrayList={volumeArrayList}
              setVolumeArrayList={setVolumeArrayList}
              loanTypesList={loanTypesList}
              branches={branches}
              setDeleteConfirm2={setDeleteConfirm2}
              setVolumeCommissionEdit={setVolumeCommissionEdit}
              volumeEditDialogOpen={volumeEditDialogOpen}
              volumeDeleteDialogOpen={volumeDeleteDialogOpen}
            />
          </>
        )}
        {/* edit individual commission start */}
        <Dialog
          fullWidth
          className="PopupBox"
          open={individualCommissionEdit}
          onClose={(e) => setIndividualCommissionEdit(false)}
        >
          <DialogTitle className="popupTitle">
            <Typography variant="h6">Edit Details</Typography>
            <IconButton onClick={(e) => setIndividualCommissionEdit(false)} size="small">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Box className="">
                  <Typography variant="h6" className="formLabel">
                    Loan Type
                  </Typography>
                  <Select
                    fullWidth
                    value={individualCommissionEditList.loanType}
                    onChange={(e) => {
                      setIndividualCommissionEditList((prev) => ({
                        ...prev,
                        loanType: e.target.value
                      }));
                    }}
                    inputProps={{
                      className: `textInput customSelectBox dissabledMenu${individualCommissionEditList.loanType}`
                    }}
                  >
                    <MenuItem value=" ">Select Loan Type</MenuItem>
                    {loanTypesList.length > 0
                      ? loanTypesList.map((item, index) => {
                          const itemValue = {
                            loanId: item.loanId,
                            loanName: item.loanName
                          };
                          return (
                            <MenuItem value={JSON.stringify(itemValue)} key={index}>
                              {item.loanName}
                            </MenuItem>
                          );
                        })
                      : ''}
                  </Select>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className="">
                  <Typography variant="h6" className="formLabel">
                    Branch
                  </Typography>
                  <Select
                    fullWidth
                    inputProps={{
                      className: `textInput customSelectBox dissabledMenu${individualCommissionEditList.branch}`
                    }}
                    value={individualCommissionEditList.branch}
                    onChange={(e) => {
                      setVolumeArrayEditList((prev) => ({
                        ...prev,
                        branch: e.target.value
                      }));
                    }}
                  >
                    <MenuItem value=" ">Select Branch</MenuItem>
                    {branches !== undefined && branches.length > 0
                      ? branches.map((item, index) => {
                          const itemValue = {
                            branchId: item.branchId,
                            branchName: item.branchName
                          };
                          return (
                            <MenuItem value={JSON.stringify(itemValue)} key={index}>
                              {item.branchName}
                            </MenuItem>
                          );
                        })
                      : ''}
                  </Select>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className="">
                  <Typography variant="h6" className="formLabel">
                    Commission %
                  </Typography>
                  <TextField
                    type="number"
                    fullWidth
                    inputProps={{
                      className: 'textInput'
                    }}
                    placeholder="Type Commission %"
                    value={individualCommissionEditList.commission}
                    onChange={(e) => {
                      setVolumeArrayEditList((prev) => ({
                        ...prev,
                        commission: e.target.value
                      }));
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => {
                handleAddIndividualEdit(e);
              }}
              variant="contained"
              className="mainBtn"
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
        {/* edit individual commission end */}
        {/* edit volune commission start */}
        <Dialog
          fullWidth
          className="PopupBox"
          open={volumeCommissionEdit}
          onClose={(e) => setVolumeCommissionEdit(false)}
        >
          <DialogTitle className="popupTitle">
            <Typography variant="h6">Edit Details</Typography>
            <IconButton onClick={(e) => setVolumeCommissionEdit(false)} size="small">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Box className="">
                  <Typography variant="h6" className="formLabel">
                    Loan Type
                  </Typography>
                  <Select
                    fullWidth
                    inputProps={{
                      className: `textInput customSelectBox dissabledMenu${volumeArrayEditList.loanType}`
                    }}
                    value={volumeArrayEditList.loanType}
                    onChange={(e) => {
                      setVolumeArrayEditList((prev) => ({
                        ...prev,
                        loanType: e.target.value
                      }));
                    }}
                  >
                    <MenuItem value=" ">Select Loan Type</MenuItem>
                    {loanTypesList.length > 0
                      ? loanTypesList.map((item, index) => {
                          const itemValue = {
                            loanId: item.loanId,
                            loanName: item.loanName
                          };
                          return (
                            <MenuItem value={JSON.stringify(itemValue)} key={index}>
                              {item.loanName}
                            </MenuItem>
                          );
                        })
                      : ''}
                  </Select>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className="">
                  <Typography variant="h6" className="formLabel">
                    Branch
                  </Typography>
                  <Select
                    fullWidth
                    inputProps={{
                      className: `textInput customSelectBox dissabledMenu${volumeArrayEditList.branch}`
                    }}
                    value={volumeArrayEditList.branch}
                    onChange={(e) => {
                      setVolumeArrayEditList((prev) => ({
                        ...prev,
                        branch: e.target.value
                      }));
                    }}
                  >
                    <MenuItem value=" ">Select Branch</MenuItem>
                    {branches !== undefined && branches.length > 0
                      ? branches.map((item, index) => {
                          const itemValue = {
                            branchId: item.branchId,
                            branchName: item.branchName
                          };
                          return (
                            <MenuItem value={JSON.stringify(itemValue)} key={index}>
                              {item.branchName}
                            </MenuItem>
                          );
                        })
                      : ''}
                  </Select>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className="">
                  <Typography variant="h6" className="formLabel">
                    Amount
                  </Typography>
                  <TextField
                    type="number"
                    fullWidth
                    inputProps={{
                      className: 'textInput'
                    }}
                    placeholder="Type Amount"
                    value={volumeArrayEditList.amount}
                    onChange={(e) => {
                      setVolumeArrayEditList((prev) => ({
                        ...prev,
                        amount: e.target.value
                      }));
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className="">
                  <Typography variant="h6" className="formLabel">
                    Duration
                  </Typography>
                  <TextField
                    fullWidth
                    inputProps={{
                      className: 'textInput'
                    }}
                    placeholder="Type Duration"
                    value={volumeArrayEditList.duration}
                    onChange={(e) => {
                      setVolumeArrayEditList((prev) => ({
                        ...prev,
                        duration: e.target.value
                      }));
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className="">
                  <Typography variant="h6" className="formLabel">
                    Commission %
                  </Typography>
                  <TextField
                    type="number"
                    fullWidth
                    inputProps={{
                      className: 'textInput'
                    }}
                    placeholder="Type Commission"
                    value={volumeArrayEditList.commission}
                    onChange={(e) => {
                      setVolumeArrayEditList((prev) => ({
                        ...prev,
                        commission: e.target.value
                      }));
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className="mb-3">
                  <Typography variant="h6" className="formLabel">
                    Unit
                  </Typography>
                  <TextField
                    fullWidth
                    inputProps={{
                      className: 'textInput'
                    }}
                    placeholder="Type Unit"
                    sx={{ marginRight: '1rem' }}
                    value={volumeArrayEditList.unit}
                    onChange={(e) => {
                      setVolumeArrayEditList((prev) => ({
                        ...prev,
                        unit: e.target.value
                      }));
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => {
                handleAddVolumeEdit(e);
              }}
              variant="contained"
              className="mainBtn"
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
        {/* edit volune commission end */}
        {/* delete individual confirm start */}
        <Dialog
          fullWidth
          className="PopupBox"
          open={deleteConfirm1}
          onClose={(e) => setDeleteConfirm1(false)}
        >
          <DialogTitle className="popupTitle">
            <Typography variant="h6">Delete Confirmation</Typography>
            <IconButton
              onClick={(e) => {
                setDeleteConfirm1(false);
              }}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Typography>Are you sure you want to delete?</Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => {
                handleDeleteBranchIndv(e, branchItemIndv, branchIndexIndv);
              }}
              variant="contained"
              className="mainBtn deleteBtn"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
        {/* delete individual confirm end */}

        {/* delete volume */}
        <Dialog
          fullWidth
          className="PopupBox"
          open={deleteConfirm2}
          onClose={(e) => setDeleteConfirm2(false)}
        >
          <DialogTitle className="popupTitle">
            <Typography variant="h6">Delete Confirmation</Typography>
            <IconButton onClick={(e) => setDeleteConfirm2(false)} size="small">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Typography>Are you sure you want to delete?</Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => {
                handleDeleteBranchVolume(e, branchItemVolume, branchIndexVolume);
              }}
              variant="contained"
              className="mainBtn deleteBtn"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
        {/* delete volume */}
      </Box>
      <Box sx={{ display: 'flex', paddingTop: '1.5rem' }}>
        <Button
          onClick={handlePrev}
          startIcon={<HiOutlineArrowNarrowLeft />}
          className="mainBtn previousBtn"
        >
          Back
        </Button>
        <Button
          onClick={(e) => handleNextStep3(e)}
          className="mainBtn nextBtn"
          endIcon={<HiOutlineArrowNarrowRight />}
          variant="contained"
        >
          Next
        </Button>
      </Box>
      <Dialog
        open={open2}
        onClose={handleClose2}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{validationMsg2}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose2}>Retry</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
